var map = {
	"./absa.config.json": 803,
	"./access.config.json": 804,
	"./boa.config.json": 805,
	"./co-operative.config.json": 806,
	"./crdb.config.json": 807,
	"./credit-bank.config.json": 808,
	"./discount-capital.config.json": 809,
	"./dtb.config.json": 810,
	"./i&m.config.json": 811,
	"./kcb-bank.config.json": 812,
	"./mhb.config.json": 813,
	"./ncba.config.json": 814,
	"./nmb.config.json": 815,
	"./premier.config.json": 816,
	"./primebank.config.json": 817,
	"./qnb.config.json": 818,
	"./sbm.config.json": 819,
	"./sidian.config.json": 820,
	"./stanbic.config.json": 821,
	"./uba.config.json": 822,
	"./umb.config.json": 823,
	"./victoria-bank.config.json": 824,
	"./zenith.config.json": 825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 802;